import script from "./ViewDataBinding.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDataBinding.vue?vue&type=script&setup=true&lang=js"

import "./ViewDataBinding.vue?vue&type=style&index=0&id=0a190cf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a190cf7"]])

export default __exports__